import {getClientConfig} from 'ultra/configs/general';

import {get, post} from '../../../Helpers/http';

const {api} = getClientConfig(window)

export function getMessages(search) {
    let link = `${api}/messages/list`;
    if (search) link += search
    return get(link);
}

export function removeAllMessages() {
    let link = `${api}/messages/flush`;
    return post(link);
}
